import { FullBooking } from '@alluradirect/react';
import { AppLink } from 'components/core/AppLink/AppLink';
import Grid from 'components/core/Grid';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import { GuestRoutesEnum } from 'routes/routes';

interface Props {
  bookingData: FullBooking | undefined;
}

export const CheckoutSummaryFooterLastStep = ({ bookingData }: Props) => {
  const isLoading = !bookingData;

  return (
    <>
      <Grid item xs={12}>
        <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
          <AppLink
            href={`${GuestRoutesEnum.booking}/${bookingData?.ID}`}
            isButtonLink
            disabled={!bookingData}
            variant="contained"
          >
            Manage Reservation
          </AppLink>
          <br />
          <br />
          <AppLink href={`${GuestRoutesEnum.booking}/${bookingData?.ID}`} isButtonLink disabled={!bookingData}>
            Contact the Host
          </AppLink>
        </LoadingSkeleton>
      </Grid>
    </>
  );
};
